module.exports = __webpack_public_path__ + "img/Cercle2.627ff870.svg";